import { type FC, type HTMLAttributes } from 'react';
import { BoostButton } from '@components/ui/BoostButton/BoostButtton';
import {
  getMaxExpiresTimeForWorkshopBoosts,
  workshopFreeBoostAvailable,
} from '@redux/selectors/workshopSelectors';
import { useAppSelector } from '@redux/store';

interface BoostWorkshopButtonProps extends HTMLAttributes<HTMLButtonElement> {
  plantId: string;
  totalBoost: number;
}

const BoostWorkshopButton: FC<BoostWorkshopButtonProps> = ({
  plantId,
  totalBoost,
  ...props
}) => {
  const time = useAppSelector((state) =>
    getMaxExpiresTimeForWorkshopBoosts(state, plantId),
  );
  const isFreeBoostAvailable = useAppSelector(workshopFreeBoostAvailable);

  return (
    <BoostButton
      isFreeBoostAvailable={isFreeBoostAvailable}
      value={totalBoost || 0}
      {...props}
      {...time}
    />
  );
};

export { BoostWorkshopButton };
